// Configuración de la API (backend dev en back-dev.achipo.cl; dev.achipo.cl es el frontend)
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://back-dev.achipo.cl',


  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/auth/login',
      REGISTER: '/api/auth/register',
      ME: '/api/auth/me',
      PERFILES: '/api/auth/perfiles',
      REFRESH: '/api/auth/refresh',
      FORGOT_PASSWORD: '/api/auth/forgot-password',
      RESET_PASSWORD: '/api/auth/reset-password'
    },

 AFILIACION: {
  ME: '/api/afiliacion/me',
  PRECIO: '/api/afiliacion/precio',
  ACTIVAR: '/api/afiliacion/activar',
  LISTAR: '/api/afiliacion',
  CREAR: '/api/afiliacion',
  OBTENER: (id) => `/api/afiliacion/${id}`,
  EDITAR: (id) => `/api/afiliacion/${id}`,
  ELIMINAR: (id) => `/api/afiliacion/${id}`
},

    ADMIN: {
      ME: '/api/admin/me',
      USUARIOS: '/api/admin/usuarios',
      STATS: '/api/admin/stats',
      VALORES_AFILIACION: '/api/admin/valores-afiliacion',
      MIEMBROS_CLUB: {
        ASOCIAR: '/api/admin/miembros-club/asociar',
        QUITAR: '/api/admin/miembros-club/quitar',
      }
    },

    GYMS: {
        LISTAR: '/api/gyms',
        CREAR: '/api/gyms',
        EDITAR: (id) => `/api/gyms/${id}`,
        ELIMINAR: (id) => `/api/gyms/${id}`
      },

   
    CLUBS: {
  LISTAR: (() => {
    return '/api/clubs';
  })(),

  CREAR: '/api/clubs',

  EDITAR: (id) => {
    return `/api/clubs/${id}`;
  },

  ELIMINAR: (id) => {
    return `/api/clubs/${id}`;
  }
},

    PRESIDENTE_CLUB: {
      ME: '/api/clubs/presidente/me',
      LISTAR_USUARIOS: '/api/clubs/presidente/usuarios',
      ASOCIAR_USUARIO: (rut) => `/api/clubs/presidente/usuarios/${rut}/asociar`,
      QUITAR_USUARIO: (rut) => `/api/clubs/presidente/usuarios/${rut}/quitar`,
    },

    EVENTOS: {
      ADMIN_LISTAR: '/api/eventos',
      CREAR: '/api/eventos',
      POSTULAR: '/api/eventos/postular',
      OBTENER: (id) => `/api/eventos/${id}`,
      EDITAR: (id) => `/api/eventos/${id}`,
      CERRAR: (id) => `/api/eventos/${id}/cerrar`,
      INSCRIBIRSE: (id) => `/api/eventos/${id}/inscribirse`,
      MIS_INSCRIPCIONES: '/api/eventos/mis-inscripciones',
      MI_INSCRIPCION: (id) => `/api/eventos/${id}/mi-inscripcion`,
      INSCRITOS: (id) => `/api/eventos/${id}/inscritos`,
      INSCRITOS_CSV: (id) => `/api/eventos/${id}/inscritos/csv`,
      CATEGORIAS_CSV: (id) => `/api/eventos/${id}/categorias/csv`,
      INSCRITOS_LIFTINGCAST_CSV: (id) => `/api/eventos/${id}/inscritos/liftingcast/csv`,
      INSCRITOS_UPLOAD: (id) => `/api/eventos/${id}/inscritos/upload-excel`,
      INSCRITOS_DESDE_POOL: (id) => `/api/eventos/${id}/inscritos/desde-pool`,
      INSCRITO_DELETE: (eventoId, inscripcionId) => `/api/eventos/${eventoId}/inscritos/${inscripcionId}`,
      PARTICIPANTES_POOL: '/api/eventos/participantes-pool',
      PARTICIPANTES_POOL_UPLOAD: '/api/eventos/participantes-pool/upload-excel',
      PARTICIPANTES_POOL_ORIGENES: '/api/eventos/participantes-pool/origenes',
      PARTICIPANTES_DISPONIBLES: (id) => `/api/eventos/${id}/participantes-disponibles`,
      POSTULACIONES: '/api/eventos/postulaciones',
      POSTULACIONES_HISTORIAL: '/api/eventos/postulaciones/historial',
      APROBAR: (id) => `/api/eventos/${id}/aprobar`,
      RECHAZAR: (id) => `/api/eventos/${id}/rechazar`,
      LIFTINGCAST: (id) => `/api/admin/liftingcast/eventos/${id}`,
      LIFTINGCAST_SINCRONIZAR: (id) => `/api/admin/liftingcast/eventos/${id}/sincronizar`
    },

    ENTRENADORES: {
      LISTAR: '/api/entrenadores',
      CREAR: '/api/entrenadores',
      OBTENER: (id) => `/api/entrenadores/${id}`,
      EDITAR: (id) => `/api/entrenadores/${id}`,
      ELIMINAR: (id) => `/api/entrenadores/${id}`
    },

    RECORDS: {
      LISTAR: '/api/records',
      LISTAR_ADMIN: '/api/records?admin=1',
      CREAR: '/api/records',
      ACTUALIZAR: (id) => `/api/records/${id}`,
      LIFTINGCAST_PREVISUALIZAR: '/api/records/liftingcast/previsualizar',
      LIFTINGCAST_PERSONAS: '/api/records/liftingcast/personas',
      LIFTINGCAST_APLICAR: '/api/records/liftingcast/aplicar'
    },

    ATLETAS: {
      LISTAR: '/api/atletas'
    },

    MARCAS: {
      LISTAR: '/api/marcas',
      ACTUALIZAR: (rut) => `/api/marcas/${rut}`,
      ENVIAR: '/api/marcas/liftingcast/enviar',
      PREVISUALIZAR: '/api/marcas/liftingcast/previsualizar',
      PROPUESTAS: '/api/marcas/propuestas',
      PROPUESTA: (id) => `/api/marcas/propuestas/${id}`,
      MIAS: '/api/marcas/mias',
      ACEPTAR: '/api/marcas/mias/aceptar',
      RECHAZAR: '/api/marcas/mias/rechazar'
    },

    RANKINGS: {
      LISTAR: '/api/rankings',
      PUBLICO: '/api/rankings/publico',
      PREVISUALIZAR: '/api/rankings/liftingcast/previsualizar',
      GUARDAR: '/api/rankings/liftingcast/guardar',
      QUITAR_CARGA: '/api/rankings/cargas'
    },

    LIFTINGCAST: {
      MEETS: '/api/admin/liftingcast/meets',
      MEET: (meetId) => `/api/admin/liftingcast/meets/${meetId}`,
      ATLETAS: (meetId) => `/api/admin/liftingcast/meets/${meetId}/atletas`,
      DIVISIONES: (meetId) => `/api/admin/liftingcast/meets/${meetId}/divisiones`,
      SINCRONIZAR: (meetId) => `/api/admin/liftingcast/meets/${meetId}/sincronizar`,
      DOPING: (meetId) => `/api/admin/liftingcast/meets/${meetId}/doping`
    }
  },

  TIMEOUT: 90000
};

// Configuración de S3 para imágenes del CMS
export const S3_CONFIG = {
  BUCKET_NAME: 'achipo-front-statics',
  REGION: 'us-east-2',
  BASE_PATH: 'public/',
  BUCKET_URL: 'https://achipo-front-statics.s3.us-east-2.amazonaws.com/',
  BASE_URL: 'https://achipo-front-statics.s3.us-east-2.amazonaws.com/public/'
};

export default API_CONFIG;
